﻿import { global, isUnDefined } from "../Common/saop-common";
import { SaopRegUraDogodekView } from "../REG/saop-regUraDogodek-view";
import { SaopServicesCore } from "../Core/saop-services-core";
import { SaopWebGrid,SaopWebGridProperties,SaopWebGridToolbar,SaopWebGridToolbarButton,SaopWebDataTable} from "../Components/saop-grid";
import * as moment from '../../node_modules/moment/moment';


export class SaopRegUraDanView extends SaopRegUraDogodekView {
    private _libNameP:string;
    private _saopServicesCore :SaopServicesCore;
    private _selectedDate:string;  
    private webGrid1:SaopWebGrid;
    private webGrid2:SaopWebGrid;
    private _addRecordEnabledId: string;
    private _addButton1Id: string;
    private _sifraZaposleni:string;

    constructor(viewId:string,libName:string = "") {
        global.ConsoleLogDegug("SaopRegUraDanView.constructor");
        super(viewId,libName);
        this._libNameP = libName;
        this._addRecordEnabledId = "#addRecordEnabled";
        this._addButton1Id = "#addButton1";
        //
        this.setDictionary();
        //
        this._saopServicesCore = new SaopServicesCore();
        //
        this.refreshData = this.refreshListData.bind(this);
    }

    initView():void{
        this.initWebGrid1();
        this.initWebGrid1Listners();
        this.initWebGrid2();
        this.bindViewData();
    }

    bindViewData():void {
        this._selectedDate = <string>$("#SelectedDate1").val();
        this._sifraZaposleni = <string>$("#reg-grid #SifraZaposleni").val();
        global.ConsoleLogDegug("selectedDate:"+this._selectedDate);
    }

    setDictionary():void{
        let dictionary:string[] = ["Brisanje","Ali ste prepričani, da želite izbrisati dogodek?"];
        this.setTerminologyList(dictionary);
    }     

    initWebGrid1():void{
        let captionToolbar = $("#saopWebGrid1").attr("caption-toolbar");
        let captionAddButton = $("#saopWebGrid1").attr("caption-addButton");
        //
        this.webGrid1 = new SaopWebGrid(this._libNameP);
        let gridProperties: SaopWebGridProperties;
        let gridToolbar:SaopWebGridToolbar;
        let toolbarButtons:SaopWebGridToolbarButton[] = [];
        //
        toolbarButtons.push({id: this._addButton1Id.replace("#",""),caption:captionAddButton,onClickEvent:this._libName+".addRecordEx();"});        
        gridToolbar = {id:"saopWebGridTB1",caption:captionToolbar,buttons:toolbarButtons};
        gridProperties = {
            gridId:"#saopWebGrid1"
            ,css:"table-column-holder-last"
            ,toolbar:gridToolbar
            ,dataTable:{enabled:true,ordering:false}
          };        
        //
        this.webGrid1.init(gridProperties);   

        this.refreshButtonsState();
    }

    initWebGrid1Listners():void{
        let _this = this;
        $(".regDayEvents_edit").off("click");
        $(".regDayEvents_edit").on('click', function(row){
            global.ConsoleLogDegug("regDayEvents_edit.click");
            let _btnEdit = row.currentTarget;
            let btnEnabled = _btnEdit.getAttribute("data-enabled");
            if (btnEnabled.toString().toLowerCase() == "true") {
                let data_idStart = _btnEdit.getAttribute("data-idstart");
                let data_idEnd = _btnEdit.getAttribute("data-idend");
                _this.editRecord({ idStart: data_idStart, idEnd: data_idEnd });
            }            
        });     
        
        $(".regDayEvents_delete").off("click");
        $(".regDayEvents_delete").on('click', function(row){
            global.ConsoleLogDegug("regDayEvents_delete.click");
            let _btnEdit = row.currentTarget;
            let btnEnabled = _btnEdit.getAttribute("data-enabled");
            if (btnEnabled.toString().toLowerCase() == "true") {
                let data_idStart = _btnEdit.getAttribute("data-idstart");
                let data_idEnd = _btnEdit.getAttribute("data-idend");
                _this.deleteRecord(
                    _this.translationService.translate("Brisanje")
                    , _this.translationService.translate("Ali ste prepričani, da želite izbrisati dogodek?")                 
                    , { idStart: data_idStart, idEnd: data_idEnd }
                    );
            }            
        });          

        $("#showPreviousDayData").off("click");
        $("#showPreviousDayData").on('click', function(row){
            global.ConsoleLogDegug("showPreviousDayData.click");
           _this.showPreviousDayData();
        });  

        $("#showNextDayData").off("click");
        $("#showNextDayData").on('click', function(row){
            global.ConsoleLogDegug("showNextDayData.click");
           _this.showNextDayData();
        });          

    }

    addRecordEx():void{
        this.addRecord({ SelectedDay:this._selectedDate, sifraZaposleni:this._sifraZaposleni });
    }      

    initWebGrid2(){
        let captionToolbar = $("#saopWebGrid2").attr("caption-toolbar");
        //
        this.webGrid2 = new SaopWebGrid(this._libNameP);
        let gridProperties: SaopWebGridProperties;
        let gridToolbar:SaopWebGridToolbar;
        //
        gridToolbar = {id:"saopWebGridTB2",caption:captionToolbar};
        gridProperties = {
            gridId:"#saopWebGrid2"
            ,toolbar:gridToolbar
            ,dataTable:{enabled:true,ordering:false}
          };        
        //
        this.webGrid2.init(gridProperties);        
    }

    showNextDayData():void{
        global.ConsoleLogDegug("SaopRegUraDanView.showNextDayData");
        let parsedDate = moment(this._selectedDate,"DD.MM.YYYY").add(1, 'days');

        //premikamo se lahko samo od prvega do zadnjega v mesecu _selectedDate
        if (moment(this._selectedDate,"DD.MM.YYYY").endOf('month').isBefore(moment(parsedDate,"DD.MM.YYYY"))){
            $('#showNextDayData').prop("disabled", true);
        }
        else {
            $('#showNextDayData').prop("disabled", false);
            let parsedDateF = parsedDate.format("DD.MM.YYYY");
            this._selectedDate = parsedDateF;
            this.refreshListData(); 
        }
    }

    showPreviousDayData():void{
        global.ConsoleLogDegug("SaopRegUraDanView.showPreviousDayData");
        let parsedDate = moment(this._selectedDate,"DD.MM.YYYY").add(-1, 'days');

        //premikamo se lahko samo od prvega do zadnjega v mesecu _selectedDate
        if (moment(this._selectedDate,"DD.MM.YYYY").startOf('month').isAfter(moment(parsedDate, "DD.MM.YYYY"))) {
            $('#showPreviousDayData').prop("disabled", true);
        }
        else {
            $('#showPreviousDayData').prop("disabled", false);
            let parsedDateF = parsedDate.format("DD.MM.YYYY");
            this._selectedDate = parsedDateF;
            this.refreshListData();
        }
    }    

    afterRefreshData():void{
        global.ConsoleLogDegug("SaopRegUraDanView.afterRefreshListData");
    }

    refreshListData(trigger:boolean = true):void{
        global.ConsoleLogDegug("SaopRegUraDanView.refreshListData");
        global.ConsoleLogDegug(trigger);
        let _this = this;
        this._saopServicesCore.afterDone = function(response){
            $("#fullscreenModalBody").html(response);

            if (trigger && _this.afterRefreshData != null){ 
                _this.afterRefreshData(); 
            }
        };
        this._saopServicesCore.ExecuteAction({
            action:"REGDayEvents/GetRegUraBrowseViewPV?SelectedDay=" + _this._selectedDate+"&employeeId="+_this._sifraZaposleni
            ,data:null
            ,type:"GET"
            ,spinnerDivId:"#saopLoadingSidebarr"
        });    
    }

    refreshButtonsState(): void {
        global.ConsoleLogDegug("SaopRegUraDanView.refreshButtonsState");

        if (typeof $(this._addRecordEnabledId).val() === 'undefined') {
            return;
        }
        let _btnAddRecordEnabled = $(this._addRecordEnabledId).val().toString();
        if (!isUnDefined(_btnAddRecordEnabled) && _btnAddRecordEnabled.toLowerCase() == "true") {
            $(this._addButton1Id).removeAttr("disabled");
        } else {
            $(this._addButton1Id).attr("disabled", "true");
        }
    }
}


